/**
 * App Theme Configuration — Danger Dan! Cinematic Pre-Launch
 *
 * Dark cinematic energy. Vibrant green + Red accents on deep black.
 * Matrix meets comic book. Bangers display font, Barlow for body.
 */

// Bangers — bold, punchy comic-book display. Barlow for body.
const font = {
  url: 'https://fonts.googleapis.com/css2?family=Bangers&family=Barlow:ital,wght@0,400;0,500;0,600;0,700;0,900;1,400&display=swap',
  family: "'Barlow', sans-serif",
};

export const theme = {
  colors: {
    background: '230 60% 6%',            // Deep dark navy #080d1f — fallback if image not loaded
    foreground: '0 0% 96%',              // Near white
    card: '230 40% 10%',                 // Dark navy card surface
    'card-foreground': '0 0% 96%',
    popover: '230 40% 10%',
    'popover-foreground': '0 0% 96%',
    primary: '90 100% 54%',              // Bright green #7CFC00
    'primary-foreground': '230 60% 6%',  // Dark navy on green
    secondary: '352 78% 57%',            // Vibrant red #E63946
    'secondary-foreground': '0 0% 96%',
    muted: '230 20% 18%',                // Dark muted navy
    'muted-foreground': '0 0% 80%',      // Light grey text
    accent: '142 76% 73%',               // Light green #86EFAC
    'accent-foreground': '230 60% 6%',   // Dark navy
    destructive: '0 72% 51%',
    'destructive-foreground': '0 0% 100%',
    border: '230 30% 20%',               // Dark navy border
    input: '230 30% 14%',                // Dark input
    ring: '90 100% 54%',                 // Green ring
    link: '90 100% 60%',
    'link-hover': '90 100% 70%',
    button: '230 40% 14%',               // Dark button
    'button-foreground': '0 0% 96%',
    'button-border': '230 30% 24%',
    'button-hover': '230 40% 20%',
    'button-hover-foreground': '0 0% 100%',
    'button-hover-border': '90 100% 54%',
    'button-ring': '90 100% 54%',
    'chart-1': '90 100% 54%',
    'chart-2': '352 78% 57%',
    'chart-3': '142 76% 73%',
    'chart-4': '160 84% 39%',
    'chart-5': '340 75% 55%',
    'sidebar-background': '230 50% 8%',  // Dark navy sidebar
    'sidebar-foreground': '0 0% 100%',
    'sidebar-primary': '90 100% 54%',
    'sidebar-primary-foreground': '230 60% 6%',
    'sidebar-accent': '230 40% 14%',
    'sidebar-accent-foreground': '0 0% 100%',
    'sidebar-border': '230 30% 20%',
    'sidebar-ring': '90 100% 54%',
  },
  font,
  radius: '0.5rem',
};
